import React from "react";
import "./loader.css";

export default function Loader({ height, scale = 1.0, ...props }) {
	
	const style = {
		height: height ? height + "px" : "60px",
		transform: `scale(${ scale })`,
		...( props.style || {})
	}

	return (
		<div className="zskstat loader-wrap" style={ style }>
			<div className="zskstat loader"> 
				<div/><div/><div/>
			</div>
		</div>
	)
}